function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-arrangeBackward");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-arrangeBackward",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5.500000, 9.125000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  points: "4 0.375 19 0.375 15 2.375 -2.8424485e-13 2.375"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,5.375 L19,5.375 L15,8.375 L13,8.375 M7,8.375 L0,8.375 L4,5.375 L7,5.375",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.25,4.875 L17.25,8.84952229 L13.25,12.875 M16.5,8.875 L3.5,8.875",
  id: "Combined-Shape",
  transform: "translate(10.000000, 8.875000) rotate(90.000000) translate(-10.000000, -8.875000) "
}))));

const SvgIco30ArrangeBackward = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ArrangeBackward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-arrangeBackward.81061282.svg";
export { ForwardRef as ReactComponent };